export default {"src":"/_next/static/media/instagram-social.5bea472b.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};